import logo from '@/assets/1xi-logo.webp';
import { APP_CONFIG } from '@/config/app.config';
import { cn } from '@/lib/cn';

export interface BrandProps {
  className?: string;
  /** Rendered height of the mark in pixels. */
  size?: number;
}

/**
 * The 1XI wordmark.
 *
 * The logo already contains the name, so there is no separate text label to
 * sit beside it — the accessible name comes from the alt text instead.
 */
export function Brand({ className, size = 26 }: BrandProps) {
  return (
    <span className={cn('inline-flex items-center', className)}>
      <img
        src={logo}
        alt={APP_CONFIG.name}
        // Width follows the intrinsic aspect ratio, so the mark never squashes.
        style={{ height: size }}
        className="w-auto select-none"
        draggable={false}
      />
    </span>
  );
}
